module.exports = __webpack_public_path__ + "static/media/igreja.52ab7472.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/igreja.jpg
// module id = 123
// module chunks = 0